<template lang="pug">
  v-row.px-1(no-gutters)
    v-card.mt-3(flat width='100%')
      v-card-title.mx-3
        h4 {{ $t('waiting-deposit') }}
      v-divider
      v-card-text 
        v-row(no-gutters justify="center") 
          v-col(cols=12 md=8)
            h3.mx-3 {{ $t('payment-method') }}
            v-list-item
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 1
              v-list-item-content {{ $t('desc.waiting-confirm-amount-deposit') }}
                div(v-if='!notDeposit')
                  | {{ $t('with-in') }} 
                  b
                    mark {{ countDownTimeString }}
                div(v-else)
                  b
                    mark.success--text  {{ $t('status') }} {{ (bankInfo.status || {}).name }} 
            .d-flex.justify-center.mt-2
              v-card(width='98%', outlined)
                v-row(no-gutters justify="center", align="center").px-4
                  v-col(cols=12 sm=6, order=2 order-sm=1)
                    v-list-item.bank-item
                      v-avatar(v-if="!isRedirectPayment").mt-2
                        v-img(:src='bankIconPath(bankInfo.admin_bank.bank_type.id)')
                      v-list-item-content.justify-center
                        div(v-if="!isRedirectPayment").bank-base-info
                          div {{ bankInfo.admin_bank.bank_type.name }}
                          b(v-if="isShowBank").mt-2.text-info {{ bankInfo.admin_bank.number }}
                          div.mt-2 {{ bankInfo.admin_bank.name }}
                          br
                          strong(v-if="isZman || isShowQr").red--text
                            | *โปรดใช้บัญชี ที่ท่านลงทะเบียนไว้ในการชำระเงิน เท่านั้น
                        .mt-1
                          v-btn(
                            v-if="(!isRedirectPayment && isShowBank && !isShowQr)"
                            block
                            dark
                            depressed
                            color='var(--bg-main-color)'
                            @click='copyText(bankInfo.admin_bank.number)'
                          ) {{ $t('button.copy') }}
                        br 
                        | {{ $t('total-payment') }}
                        .mt-1
                          mark.text-center
                            h1 {{ bankInfo.request_amount | currency }}
                            v-card-actions(v-if='!notDeposit')

                        .mt-1
                          v-btn(
                            v-if="bankInfo.admin_bank.qr_image_url"
                            block
                            dark
                            depressed
                            color='var(--bg-main-color)'
                            @click='copyText(bankInfo.request_amount)'
                          ) คัดลอกยอดชำระ
                    v-list-item(v-if='isCanConfirm').justify-center
                      v-btn(
                        depressed
                        @click='cancelTopup'
                      ).mx-2 {{ $t('button.cancel-deposit-amount') }}
                      v-btn(
                        v-if="!isRedirectPayment && !isZman && !isShowQr"
                        depressed
                        color='var(--bg-secondary-color)'
                        dark
                        @click='paymentInfo'
                      ).mx-2 {{ $t('button.deposit-amount') }}
                  v-col(v-if="bankInfo.admin_bank.qr_image_url" cols=12 sm=4, order=1 order-sm=2)
                    div.my-1.px-5
                      v-img(:src='bankInfo.admin_bank.qr_image_url', width="100%")
                    div.mb-5
                      v-btn(
                        block
                        dark
                        depressed
                        color='var(--bg-main-color)'
                        @click='download_qr'
                      ) บันทึกภาพ QR code
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 2
              v-list-item-content {{ $t('desc.keep-evidence-deposit') }}
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 3
              v-list-item-content {{ $t('desc.waiting-deposit') }}
    dialog-inform(
      ref='dialog'
      @next='nextPage'
    )
</template>
<script> 
import { credits as apiCredits } from '@/apis'  
import { getMinuteTime } from '@/plugins/time' 
import { bankIconPath } from '@/plugins/mapImage' 
import dialogInform from './dialogInform.vue' 
import * as c from '@/const/setTimeOutConfig'
import { ROUTE_DEPOSIT,ROUTE_INDEX, ROUTE_TRASACTION } from '@/const/route'

const PAPAYA_PAY = 17
const BITPAY = 23
const ZMAN = 33
const JJ = 36
const WORLDPAY = 37
const ANY_PAY = 38

export default {
  components : {
    dialogInform, 
  },  
  props : {
    bankInfo : {
      type : Object,
      default : () => {}
    }
  },
  data () {
    return { 
      secondIcon:'grey', 
      countDownTime:this.bankInfo.expire_in, 
      copyAccountNumberText:this.$t('copy-account-number'),  
      uuid : this.bankInfo.uuid,
      notDeposit:false
    } 
  },
  computed : {
    PAPAYA_PAY () { return PAPAYA_PAY},
    countDownTimeString () {
      return getMinuteTime(this.countDownTime)
    },
    isCanConfirm () {
      return this.bankInfo.request_confirmed_at === null
    },
    isRedirectPayment () {
      return this.bankInfo.admin_bank.bank_type.id == PAPAYA_PAY
    },
    isZman () {
      return this.bankInfo.admin_bank.bank_type.id == ZMAN
    },
    isShowQr () {
      const qrBanks = [BITPAY, JJ, WORLDPAY, ANY_PAY];
      return qrBanks.includes(this.bankInfo.admin_bank.bank_type.id);
    },
    isShowBank () {
      return !this.bankInfo.redirect_to
    },
  },
  watch : {
    countDownTime () {
      if(this.countDownTime===0){
        this.$alert('',this.$t('message.timeout-deposit-confirm'),'warning')  
      }
    }
  },  
  async created () { 
    if((this.bankInfo.status || {}).id!==2){ 
      this.countDownTimer ()
    } else {
      this.notDeposit = true
    }
  },
  methods : {  
    bankIconPath,  
    redirectToindex () {
      if(this.countDownTime===0){
        this.$router.push({
          name:ROUTE_TRASACTION
        }).catch(()=>{});  
      } else{
        this.$router.push({
          name:ROUTE_INDEX
        }).catch(()=>{});  
      } 
    },
    async cancelTopup () {
      this.$ga.event('Button', 'CancelDeposit', 'DepositPage','' )

      const [err,] = await apiCredits.cancel(this.bankInfo.uuid)
      
      if(err) {
        this.$alert('',err,'warning').then(()=>{ 
          this.redirectToindex() 
        }) 
        return
      }
    
      this.$router.push({
        name:ROUTE_INDEX
      }).catch(()=>{});    
    },
    countDownTimer () {  
      if(this.$route.name !== ROUTE_DEPOSIT){
        return
      }

      if(this.countDownTime > 0) {
        setTimeout(() => {
            this.countDownTime -= 1 
            this.countDownTimer()
        }, c.COUNTDOWNONESEC)
      } else  {
        this.cancelTopup()
      }
    },
    async copyText (text) {
      try {
        await navigator.clipboard.writeText(text);
        alert('คัดลอกสำเร็จ');
      } catch($e) {
        alert('ไม่สามารถคัดลอกได้');
      }
    },
    copyAccountNumber () {
      this.$ga.event('Button', 'CoppyAccountNumber', 'DepositPage','' )
      this.copyAccountNumberText = this.$t('copied-account-number')
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy); 
      dummy.value = this.bankInfo?.admin_bank?.number;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);     
          
      setTimeout(()=>
        this.copyAccountNumberText = this.$t('copy-account-number') 
        ,c.COPYACCOUNTTOPUP) 
    },
    async download_qr () {
      const blob = await fetch(this.bankInfo.admin_bank.qr_image_url).then(res => res.blob())
      const url = URL.createObjectURL(blob)
      const a = Object.assign(document.createElement('a'), {
        href: url,
        download: '', // or leave blank to let the browser decide
      })
      document.body.append(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)

      alert('บันทึกสำเร็จ');
    },
    nextPage () {
      //แจ้งถอนนะจ๊ะ
      this.$emit('next')
    } ,
    paymentInfo () {
      this.$ga.event('Button', 'OpenDialogInform', 'DepositPage','' )
      this.$refs.dialog.openDialog(this.bankInfo.request_amount,this.uuid)
    }
  }
}
</script>
<style scoped> 
.bank-item {
  align-items: flex-start;
  gap: 16px;
}

.bank-base-info {
  display: flex;
  flex-direction: column;
}

.text-info {
  font-size: 1.125rem;
}
</style>
